{
  "pt_BR": "hostels",
  "cs_CZ": "ubytovny",
  "da_DK": "vandrerhjem",
  "de_DE": "jugendherbergen",
  "en_GB": "hostels",
  "es_ES": "albergues",
  "fi_FI": "hostellit",
  "fr_FR": "auberges-de-jeunesse",
  "it_IT": "ostelli",
  "ja_JP": "hosuteru",
  "ko_KR": "hoseuterdeur",
  "nl_NL": "hostels",
  "nb_NO": "vandrerhjem",
  "pl_PL": "schroniska",
  "pt_PT": "albergues",
  "ru_RU": "khostely",
  "sv_SE": "vandrarhem",
  "tr_TR": "hostels",
  "zh_CN": "lushe"
}
